import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { UserContext } from '../../../../../user/UserContext';
import { DecisionUploadContext } from '../../DecisionUploadContext';
import styles from './decision_upload_success.module.scss';
import { BrandButton } from '../../../../../components/button';

type Props = {
  reset: (value?: boolean | undefined) => void;
};

export const DecisionUploadSuccess: FC<Props> = ({ reset }) => {
  const { plansAllowed } = useContext(DecisionUploadContext);
  const { currentUser } = useContext(UserContext);

  const warnNonPayingUser =
    !currentUser ||
    (!plansAllowed.includes(currentUser.plan) && !currentUser.verified);

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <FormattedMessage id="upload/decision-upload/components/DecisionUploadSuccess.tsx/1" />
      </div>
      <div className={styles.text}>
        {!warnNonPayingUser ? (
          <FormattedMessage id="upload/decision-upload/components/DecisionUploadSuccess.tsx/2" />
        ) : (
          <FormattedMessage id="upload/decision-upload/components/DecisionUploadSuccess.tsx/3" />
        )}
      </div>
      <BrandButton onClick={() => reset()}>
        <FormattedMessage id="upload/decision-upload/components/DecisionUploadSuccess.tsx/4" />
      </BrandButton>
    </div>
  );
};
